import { httpGet } from "../../../Util/http";
import { addAlert } from "../../../MsgNotify/msgNotifyActions";

export const INIT_STATE = "INIT_STATE";
export const initState = () => {
  return {
    type: INIT_STATE,
  };
};

export const cleanup = () => {
  return (dispatch) => {
    dispatch(initState());
  };
};

export const GET_PCALC_REQUEST = "GET_PCALC_REQUEST";
export const getPcalcRequest = () => {
  return {
    type: GET_PCALC_REQUEST,
  };
};

export const GET_PCALC_SUCCESS = "GET_PCALC_SUCCESS";
export const getPcalcSuccess = (data, showNotInvoicedOnly) => {
  return {
    type: GET_PCALC_SUCCESS,
    materiels: data.materiels,
    pCalc: data.pCalc,
    client: data.client,
    project: data.project,
    workplaceName: data.workplaceName,
    stade: false,
    showNotInvoicedOnly,
  };
};

export const GET_PCALC_PROJECT_SUCCESS = "GET_PCALC_PROJECT_SUCCESS";
export const getPcalcFromProjectSuccess = (data, showNotInvoicedOnly) => {
  return {
    type: GET_PCALC_PROJECT_SUCCESS,
    materiels: data.materiels,
    pCalc: data.pCalc,
    stade: true,
    showNotInvoicedOnly,
  };
};

export const GET_PCALC_FAILURE = "GET_PCALC_FAILURE";
export const getPcalcFailure = () => {
  return {
    type: GET_PCALC_FAILURE,
  };
};

export const getPcalc = (
  workplaceId,
  dateFrom,
  dateTo,
  showNotInvoicedOnly = false
) => {
  dateFrom = JSON.parse(JSON.stringify(dateFrom));
  dateTo = JSON.parse(JSON.stringify(dateTo));
  var _url =
    process.env.REACT_APP_webApiEndPoint +
    `api/dailyreports/${workplaceId}/pcalc?dateFrom=${dateFrom}&dateTo=${dateTo}&showNotInvoicedOnly=${showNotInvoicedOnly}`;
  return (dispatch) => {
    dispatch(getPcalcRequest());
    return httpGet(_url)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        dispatch(getPcalcSuccess(json, showNotInvoicedOnly));
      })
      .catch((e) => {
        console.error(e);
        dispatch(getPcalcFailure());
        dispatch(
          addAlert("Kunne ikke hente data, prøv at ændre de valgte datoer")
        );
      });
  };
};

export const getPcalcProject = (
  projectId,
  dateFrom,
  dateTo,
  showNotInvoicedOnly = false
) => {
  dateFrom = JSON.parse(JSON.stringify(dateFrom));
  dateTo = JSON.parse(JSON.stringify(dateTo));
  var _url =
    process.env.REACT_APP_webApiEndPoint +
    `api/dailyreports/project/${projectId}/pcalc?dateFrom=${dateFrom}&dateTo=${dateTo}&showNotInvoicedOnly=${showNotInvoicedOnly}`;
  return (dispatch) => {
    dispatch(getPcalcRequest());
    return httpGet(_url)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        console.log(json);
        dispatch(getPcalcFromProjectSuccess(json, showNotInvoicedOnly));
      })
      .catch((e) => {
        console.error(e);
        dispatch(getPcalcFailure());
        dispatch(
          addAlert("Kunne ikke hente data, prøv at ændre de valgte datoer")
        );
      });
  };
};

export const getPcalcProjects = (
  projectIds,
  dateFrom,
  dateTo,
  showNotInvoicedOnly = false
) => {
  dateFrom = JSON.parse(JSON.stringify(dateFrom));
  dateTo = JSON.parse(JSON.stringify(dateTo));
  var _url =
    process.env.REACT_APP_webApiEndPoint +
    `api/dailyreports/projects/pcalc?projectIds=${projectIds.join(
      ","
    )}&dateFrom=${dateFrom}&dateTo=${dateTo}&showNotInvoicedOnly=${showNotInvoicedOnly}`;
  return (dispatch) => {
    dispatch(getPcalcRequest());
    return httpGet(_url)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        console.log(json);
        dispatch(getPcalcFromProjectSuccess(json, showNotInvoicedOnly));
      })
      .catch((e) => {
        console.error(e);
        dispatch(getPcalcFailure());
        dispatch(
          addAlert("Kunne ikke hente data, prøv at ændre de valgte datoer")
        );
      });
  };
};

export const UPDATE_CREW_RATE = "UPDATE_CREW_RATE";
export const updateCrewRate = (functionType, rateType, val) => {
  return {
    type: UPDATE_CREW_RATE,
    functionType: functionType,
    rateType: rateType,
    val: val,
  };
};

export const updateCrew = (functionType, rateType, val) => {
  return (dispatch) => {
    dispatch(updateCrewRate(functionType, rateType, val));
  };
};

export const UPDATE_DELIVERYNOTE_PRICE = "UPDATE_DELIVERYNOTE_PRICE";
export const updateDeliverynotePrice = (index, val) => {
  return {
    type: UPDATE_DELIVERYNOTE_PRICE,
    index: index,
    val: val,
  };
};

export const UPDATE_DELIVERYNOTE_PROCENTAGE = "UPDATE_DELIVERYNOTE_PROCENTAGE";
export const updateDeliverynoteProcentage = (index, val) => {
  return {
    type: UPDATE_DELIVERYNOTE_PROCENTAGE,
    index: index,
    val: val,
  };
};

export const updateDeliveryNote = (index, val) => {
  return (dispatch) => {
    dispatch(updateDeliverynotePrice(index, val));
  };
};

export const UPDATE_MATERIEL_PRICE = "UPDATE_MATERIEL_PRICE";
export const updateMaterielPrice = (id, val) => {
  return {
    type: UPDATE_MATERIEL_PRICE,
    id: id,
    val: val,
  };
};

export const UPDATE_MEASUREMENT_PRICE = "UPDATE_MEASUREMENT_PRICE";
export const updateMeasurementPrice = (index, val) => {
  return {
    type: UPDATE_MEASUREMENT_PRICE,
    index,
    val,
  };
};

export const UPDATE_ACTIVITIES_PRICE = "UPDATE_ACTIVITIES_PRICE";
export const updateActivitiesPrice = (index, val) => {
  return {
    type: UPDATE_ACTIVITIES_PRICE,
    index,
    val,
  };
};



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/PCalc/actions.js